/**
 * Created by Ivan on 01.08.2026
 */

const BalloonRiseLoseTimer = function (mission, lastProgressTime) {
    this.mission = mission;
    this.lastProgressTime = lastProgressTime || Date.now();

    cleverapps.dataLoader.save(DataLoader.TYPES.BALLOON_RISE_MERGE2, { lastProgressTime: this.lastProgressTime });
    this.mission.logic.loseTimerFinishTime = this.lastProgressTime + BalloonRiseLoseTimer.LOSE_TIMEOUT;

    this.scheduleTimeout();
};

BalloonRiseLoseTimer.prototype.getTimeLeft = function () {
    return Math.max(0, this.lastProgressTime + BalloonRiseLoseTimer.LOSE_TIMEOUT - Date.now());
};

BalloonRiseLoseTimer.prototype.scheduleTimeout = function () {
    this.clearTimeout();

    const timeLeft = this.getTimeLeft();
    if (timeLeft <= 0) {
        return;
    }

    this.timeout = cleverapps.timeouts.setTimeout(() => {
        this.timeout = undefined;
        this.onExpiredCallback && this.onExpiredCallback();
    }, timeLeft);
};

BalloonRiseLoseTimer.prototype.clearTimeout = function () {
    if (this.timeout) {
        cleverapps.timeouts.clearTimeout(this.timeout);
        this.timeout = undefined;
    }
};

BalloonRiseLoseTimer.prototype.remove = function () {
    this.clearTimeout();
    this.mission.logic.loseTimerFinishTime = undefined;
    cleverapps.dataLoader.remove(DataLoader.TYPES.BALLOON_RISE_MERGE2);
};

BalloonRiseLoseTimer.LOSE_TIMEOUT = cleverapps.parseInterval("60 minutes");
